module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-top-panel-4-fa8949f8594a3832c017a742aa1c9406.svg";